<template>
  <div id="content" class="main-content">
    <div class="layout-px-spacing">
      <div class="chat-section layout-top-spacing">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12">
            <div class="table-responsive">
              <table class="table mb-4">
                <thead>
                  <tr>
                    <th class="text-center">#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date Created</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, i) in residents" :key="i">
                    <td class="text-center">{{i+1}}</td>
                    <td class="text-primary">{{user.local.fullname}}</td>
                    <td>{{user.local.email}}</td>
                    <td>{{user.createdAt}}</td>
                    <td>
                      <router-link :to="{name: 'view-user-profile', params: {userId: user._id, type: userType.USER}}" >View Profile</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="no-estate">
                <h5 v-if="!residents.length" >No Resident Record</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer />

  </div>
</template>

<script>
import {USER_TYPE} from '../../helpers/userType';
import Footer from './Footer';

export default {
  components: {
    Footer,
  },
  data(){
    return {
      userType: USER_TYPE,
    }
  },
   mounted(){
    this.$store.dispatch('GET_ALL_PROPERTY_RESIDENTS');
  },
  computed: {
    residents() {
      const items = this.$store.getters.getPropertyResidents;
      return items ? items : [];
    }
  }
};
</script>

<style scoped>
.no-estate {
  display: flex;
  justify-content: center;
}
</style>